import WebApi from "@/views/loyalty/shared/modules/web_api"

export function createParticipant (clients, participantId, participantNumber) {
    console.log('createParticipant clients', clients)
    console.log('createParticipant participantId', participantId)
    console.log('createParticipant participantNumber', participantNumber)
    const customers = clients.map(client => ({ customerId: client.id, customerNumber: client.number }))
    console.log('customer', customers)
    if (participantId !== undefined) {
    const webApi = new WebApi()
    webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/accounts/${participantId}/${participantNumber}`, customers)
        .then()
    // create token for saved user (staff) <- disabled
    //     webApi.post(`${process.env.VUE_APP_LOYALTY_URL}auth/staff/${participantId}`)
    //         .then()
    }
}
